var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _vm.showButton ? _c('el-button', { staticClass: "download-all-resources", attrs: { "loading": _vm.loading, "disabled": _vm.$attrs.disabled }, on: { "click": _vm.handleDownloadResource } }, [_vm._v(_vm._s(_vm.$t('playTurbo.versionlist.actionButton.copyAllResource')))]) : _vm._e();
};
var staticRenderFns = [];

export { render, staticRenderFns };